import api from '@/config/axios';
import { POST_CLONE_TEMPLATE } from '@/config/endpoints';

export type CloneTemplatePayload = {
  name: string;
  settings: Record<string, unknown>;
};
export type CloneTemplateResponse = {
  id: string;
  short_id: string;
  slug: string;
};

export const useCloneTemplate = () => {
  function cloneTemplate(projectId: string, payload: CloneTemplatePayload) {
    return api.post<CloneTemplateResponse>(
      POST_CLONE_TEMPLATE.endpoint(projectId),
      payload
    );
  }

  return { cloneTemplate };
};
